exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title__root___36VGd{margin:0;padding:0 0 10px;font-weight:600;line-height:normal;text-align:left;letter-spacing:normal;font-stretch:normal}.Title__mega___2PWsg,.Title__root___36VGd{font-family:Circular Std,Circular,Open Sans,arial,sans-serif}.Title__mega___2PWsg{font-size:45px;line-height:50px;letter-spacing:-3px;font-weight:800}@media (min-width:768px){.Title__mega___2PWsg{font-size:60px;line-height:60px}}.Title__huge___2A3Gc{font-size:40px;letter-spacing:-1px}@media (min-width:768px){.Title__huge___2A3Gc{font-size:45px}}.Title__large___39KZu{font-size:28px;letter-spacing:-1px}@media (min-width:768px){.Title__large___39KZu{font-size:36px}}.Title__medium___2FHB6{font-size:24px;padding:0 0 10px;line-height:1.3}.Title__small___2tOfx{font-size:18px;padding:0 0 5px}.Title__tiny___3kJj2{font-size:14px;letter-spacing:0;padding:0}.Title__light___2wp-i{font-weight:400}.Title__inverted___137KG{color:#fff}.Title__red___3nBEO{color:#f06868}.Title__centered___13sdy{text-align:center}@media (max-width:767px){.Title__centeredMobile___1-bDg{text-align:center}}.Title__highlighted___2Xooj{color:#41abc2}.Title__shadow___3KRno{text-shadow:1px 1px 1px rgba(43,48,65,.5)}.Title__error___35RkS{color:#f06868}", ""]);

// exports
exports.locals = {
	"root": "Title__root___36VGd",
	"mega": "Title__mega___2PWsg",
	"huge": "Title__huge___2A3Gc",
	"large": "Title__large___39KZu",
	"medium": "Title__medium___2FHB6",
	"small": "Title__small___2tOfx",
	"tiny": "Title__tiny___3kJj2",
	"light": "Title__light___2wp-i",
	"inverted": "Title__inverted___137KG",
	"red": "Title__red___3nBEO",
	"centered": "Title__centered___13sdy",
	"centeredMobile": "Title__centeredMobile___1-bDg",
	"highlighted": "Title__highlighted___2Xooj",
	"shadow": "Title__shadow___3KRno",
	"error": "Title__error___35RkS"
};